import { useRepositoryMutation } from '@mews-commander/data-access';

export const useCentralCancellationPolicyDelete = () =>
    useRepositoryMutation('portfolioCentralCancellationPolicies', 'delete', {
        invalidateQueries: {
            portfolioCentralCancellationPolicies: ['getOverviewEntries', 'getAll'],
            portfolioCentralRateGroups: ['getAll', 'getOverview'],
        },
    });
